import Toggle from "../../components/Toggle";

const FONTS = [
  "Outfit", "Plus Jakarta Sans", "Inter", "Poppins", "Montserrat", "Playfair Display",
  "Merriweather", "Lora", "Roboto Slab", "Space Grotesk", "DM Sans", "Nunito", "Raleway", "Work Sans",
];

function ColorField({ label, value, onChange, testid }) {
  return (
    <div>
      <label className="text-sm font-medium text-[#1A231C]">{label}</label>
      <div className="mt-1 flex items-center gap-2 border border-[#E8E4D9] rounded-lg px-3 py-2">
        <input type="color" data-testid={testid} value={value || "#000000"} onChange={(e) => onChange(e.target.value)} className="w-9 h-9 rounded cursor-pointer border-0 bg-transparent" />
        <input value={value || ""} onChange={(e) => onChange(e.target.value)} className="flex-1 text-sm focus:outline-none" />
      </div>
    </div>
  );
}

export default function AdminTheme({ settings, setField, onSave, saving }) {
  return (
    <form onSubmit={onSave} className="mt-6 max-w-2xl space-y-6">
      <div className="bg-white border border-[#E8E4D9] rounded-xl p-6 space-y-4">
        <h3 className="font-display font-semibold text-lg text-[#1A231C]">Colors</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <ColorField label="Primary" value={settings.theme_primary} onChange={(v) => setField("theme_primary", v)} testid="theme-primary" />
          <ColorField label="Primary (hover)" value={settings.theme_primary_hover} onChange={(v) => setField("theme_primary_hover", v)} testid="theme-primary-hover" />
          <ColorField label="Accent" value={settings.theme_accent} onChange={(v) => setField("theme_accent", v)} testid="theme-accent" />
          <ColorField label="Page Background" value={settings.theme_bg} onChange={(v) => setField("theme_bg", v)} testid="theme-bg" />
          <ColorField label="Header Background" value={settings.theme_header_bg} onChange={(v) => setField("theme_header_bg", v)} testid="theme-header-bg" />
          <ColorField label="Footer Background" value={settings.theme_footer_bg} onChange={(v) => setField("theme_footer_bg", v)} testid="theme-footer-bg" />
        </div>
      </div>

      <div className="bg-white border border-[#E8E4D9] rounded-xl p-6 space-y-4">
        <h3 className="font-display font-semibold text-lg text-[#1A231C]">Fonts</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="text-sm font-medium text-[#1A231C]">Heading Font</label>
            <select data-testid="theme-font-heading" value={settings.theme_font_heading || "Outfit"} onChange={(e) => setField("theme_font_heading", e.target.value)} className="w-full mt-1 bg-white border border-[#E8E4D9] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--brand-primary)]">
              {FONTS.map((f) => (<option key={f} value={f}>{f}</option>))}
            </select>
          </div>
          <div>
            <label className="text-sm font-medium text-[#1A231C]">Body Font</label>
            <select data-testid="theme-font-body" value={settings.theme_font_body || "Plus Jakarta Sans"} onChange={(e) => setField("theme_font_body", e.target.value)} className="w-full mt-1 bg-white border border-[#E8E4D9] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--brand-primary)]">
              {FONTS.map((f) => (<option key={f} value={f}>{f}</option>))}
            </select>
          </div>
        </div>
      </div>

      <div className="bg-white border border-[#E8E4D9] rounded-xl p-6 space-y-4">
        <h3 className="font-display font-semibold text-lg text-[#1A231C]">Announcement Bar (Marquee)</h3>
        <div className="flex items-center justify-between border border-[#E8E4D9] rounded-lg px-4 py-3">
          <span className="text-sm text-[#1A231C]">Show scrolling top bar</span>
          <Toggle checked={!!settings.marquee_enabled} onChange={(v) => setField("marquee_enabled", v)} testid="toggle-marquee" />
        </div>
        <div>
          <label className="text-sm font-medium text-[#1A231C]">Marquee Text</label>
          <input data-testid="marquee-text" value={settings.marquee_text || ""} onChange={(e) => setField("marquee_text", e.target.value)} placeholder="e.g. Free home delivery on orders above $50!" className="w-full mt-1 bg-white border border-[#E8E4D9] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--brand-primary)]" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <ColorField label="Bar Background" value={settings.marquee_bg} onChange={(v) => setField("marquee_bg", v)} testid="marquee-bg" />
          <ColorField label="Bar Text Color" value={settings.marquee_text_color} onChange={(v) => setField("marquee_text_color", v)} testid="marquee-text-color" />
        </div>
      </div>

      <button data-testid="theme-save" type="submit" disabled={saving} className="bg-[var(--brand-primary)] text-white px-6 py-3 rounded-lg font-medium hover:bg-[var(--brand-primary-hover)] transition-colors disabled:opacity-60">
        {saving ? "Saving..." : "Save Theme"}
      </button>
    </form>
  );
}
